import axios from 'axios'
// import Message from 'js-message'

// create an axios instance
const service = axios.create({
  // baseURL: process.env.BASE_API, // api的base_url
  baseURL: window.BASE_API, // api的base_url
  timeout: 20000, // request timeout
    responseType: 'json',
    withCredentials: false, // 表示跨域请求时是否需要使用凭证
})

// request interceptor
service.interceptors.request.use(

  config => {
    // console.log(config);
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// respone interceptor
service.interceptors.response.use(
  response => response,
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
